<div class="cadastro-lote-wrapper">

  <div class="cards-header">
    <div [formGroup]="form" class="inline-element cards-header-actions">
      <div class="floatlabel-field">
        <p-floatlabel variant="on">
          <p-datepicker [showIcon]="true" dateFormat="dd/mm/yy" formControlName="dataLote" [fluid]="true" />
          <label>Data do lote</label>
        </p-floatlabel>
        <small class="p-error"
          [ngClass]="{'visibility-hidden': !form.get('dataLote')?.hasError('required') || !form.get('dataLote')?.touched }">Campo
          obrigatório</small>
      </div>

      <div class="floatlabel-field">
        <p-floatlabel variant="on">
          <input pInputText type="text" formControlName="nomeLote" class="nome-lote-input"/>
          <label>Nome do lote</label>
        </p-floatlabel>
        <small class="p-error"
          [ngClass]="{'visibility-hidden': !form.get('nomeLote')?.hasError('required') || !form.get('nomeLote')?.touched }">Campo
          obrigatório</small>
      </div>

      <button class="white-text-button btn-buscar" mat-flat-button
        (click)="buscarClick()" [disabled]="modoEdicao" [disableNoPermission]="permissaoEditarLancamento">
        Buscar
      </button>
    </div>
    <div class="diferenca-section">
      <span class="diferenca-label">Diferença:</span>
      <span class="diferenca-valor" [class.diferenca-diferente]="diferenca !== 0">
        {{ diferenca | currency:'BRL' }}
      </span>
    </div>
    <div class="cards-header-left">
      <button mat-stroked-button (click)="toggleTabDirecao()"
        [pTooltip]="tabCruzado ? 'Tab vai para o outro card' : 'Tab fica no mesmo card'"
        tooltipPosition="bottom">
        Tab <i [class]="tabCruzado ? 'pi pi-arrow-right' : 'pi pi-arrow-down'"></i>
      </button>
    </div>
  </div>

  <div class="splitter-wrapper">
    <p-splitter [style]="{ height: '100%' }" class="mb-8">
      <ng-template #panel>
        <div class="splitter-panel-content">
          <app-card-lote-lancamentos #cardCreditos prefix="left" [tiposLancamento]="tiposLancamento"
            titulo="Créditos" [form]="creditosForm" [tabCruzado]="tabCruzado"
            (tabFromLastRow)="onTabFromLastRowCreditos()"></app-card-lote-lancamentos>
        </div>
      </ng-template>

      <ng-template #panel>
        <div class="splitter-panel-content">
          <app-card-lote-lancamentos #cardDebitos prefix="right" [tiposLancamento]="tiposLancamento"
            titulo="Débitos" [form]="debitosForm" [tabCruzado]="tabCruzado"
            (tabFromLastRow)="onTabFromLastRowDebitos()"></app-card-lote-lancamentos>
        </div>
      </ng-template>
    </p-splitter>
  </div>

</div>
